export default {
  allVehicles: [],
  vehicle: {},
}
